export const basename = (fullPath) => {
  if (fullPath) return fullPath.replace(/^.*[\\/]/, "");

  return null;
};
